import { render, staticRenderFns } from "./SetColorAndLogoReminder.vue?vue&type=template&id=10759b38&scoped=true&"
import script from "./SetColorAndLogoReminder.vue?vue&type=script&lang=js&"
export * from "./SetColorAndLogoReminder.vue?vue&type=script&lang=js&"
import style0 from "./SetColorAndLogoReminder.vue?vue&type=style&index=0&id=10759b38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10759b38",
  null
  
)

export default component.exports